export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5148.8cc60293.jpg";